import { flow, isNil, debounce } from 'lodash/fp';

export const _ = {
  flow,
  isNil,
  debounce,
};

export default _;
